module.exports = __webpack_public_path__ + "static/media/ziwaibaojing.02eff15.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/ziwaibaojing.mp3
// module id = lTDZ
// module chunks = 208